import Link from "next/link";
import { useRouter } from "next/router";

// Breadcrumb data tree
const defaultBreadcrumbTree = [
  {
    title: "Help & Support",
    url: "/help",
    children: [
      {
        title: "Customer care",
        url: "/help/customer-care",
        children: [
          {
            title: "Accessibility",
            url: "/help/customer-care/accessibility",
          },
          {
            title: "Financial Support",
            url: "/help/customer-care/financial-support",
          },
          {
            title: "How do I raise a complaint?",
            url: "/help/customer-care/complaints",
          },
          {
            title: "Third Party Authorisation",
            url: "/help/customer-care/third-party",
          },
        ],
      },
      {
        title: "FAQs",
        url: "/help/faq",
      },
      {
        title: "Foreign Exchange",
        url: "/help/fx",
      },
      {
        title: "Fraud Prevention",
        url: "/help/fraud-prevention",
        children: [
          {
            title: "How to keep yourself safe",
            url: "/help/fraud-prevention/keep-safe",
          },
          {
            title: "How to report fraud",
            url: "/help/fraud-prevention/report-fraud",
          },
          {
            title: "Issue with a transaction",
            url: "/help/fraud-prevention/issue-transaction",
          },
          // {
          //   title:"Article Hub",
          //   url:"/help/fraud-prevention/article-hub"
          // }
        ],
      },
    ],
  },
];

// Iterative function to find the breadcrumb path
const findBreadcrumbPath = (tree, currentPath) => {
  const path = [];
  let stack = [...tree];

  while (stack.length > 0) {
    const node = stack.shift();

    if (currentPath.startsWith(node.url)) {
      path.push({ title: node.title, url: node.url });

      if (node.children) {
        stack = [...node.children];
      }
    }
  }

  return path;
};

const Breadcrumb = ({ breadcrumbTree = defaultBreadcrumbTree }) => {
  const router = useRouter();
  const currentPath = router.asPath;

  const breadcrumbPath = findBreadcrumbPath(breadcrumbTree, currentPath);

  return (
    <div className="inline-block truncate">
      <span aria-label="breadcrumb" className="inline">
        {breadcrumbPath.map((breadcrumb, index) => {
          const isLast = index === breadcrumbPath.length - 1;

          return (
            <span key={breadcrumb.url}>
              {index > 0 && (
                <span className="text-onmoPrimary px-1 font-medium 4xl:text-2xl">
                  /
                </span>
              )}
              {isLast ? (
                <span
                  className="whitespace-nowrap text-onmoPrimaryBlack font-medium 4xl:text-2xl"
                  aria-current="page"
                >
                  {breadcrumb.title}
                </span>
              ) : (
                <Link
                  href={breadcrumb.url}
                  className="text-onmoPrimary hover:underline whitespace-nowrap font-medium 4xl:text-2xl"
                >
                  {breadcrumb.title}
                </Link>
              )}
            </span>
          );
        })}
      </span>
    </div>
  );
};

export default Breadcrumb;
